import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const FormulaOneIcon = observer('FormulaOneIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M5.84601 15.0769V21.2307C5.84601 21.6556 5.50162 22 5.07679 22C4.65196 22 4.30756 21.6556 4.30756 21.2307V2.76923C4.30756 2.3444 4.65196 2 5.07679 2C5.50162 2 5.84601 2.3444 5.84601 2.76923H18.923C19.3478 2.76923 19.6921 3.11362 19.6921 3.53846V14.3077C19.6921 14.7325 19.3478 15.0769 18.923 15.0769H5.84601ZM8.92297 4.30769V7.38458H5.84601V10.4615H8.92297V13.5385H18.1537V4.30769H8.92297ZM11.9999 4.30769H15.0768V7.38458H11.9999V4.30769ZM8.92297 7.38458H11.9999V10.4615H8.92297V7.38458ZM15.0768 7.38458H18.1537V10.4615H15.0768V7.38458ZM11.9999 10.4615H15.0768V13.5385H11.9999V10.4615Z'
                fill='fill'
            />
        </SvgElement>
    );
});
